/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { ResolutionSummaryConflicts } from "./ResolutionSummaryConflicts";
import { SchemaDiffRecord } from "../../snapshots/types/SchemaDiffRecord";
import { SheetConfig } from "../../sheets/types/SheetConfig";
export const ResolutionSummary = core.serialization.object({
    total: core.serialization.number(),
    conflicts: ResolutionSummaryConflicts,
    markedForDeletion: core.serialization.number(),
    schemaDiff: SchemaDiffRecord,
    config: SheetConfig,
});
